import React from "react";
import { Formik, Field, Form, FastField } from "formik";
import { object, string } from "yup";
import { Api } from "../../utils/api";
import { MaterialSelectFormik } from "../components/select-field.component";
import { TextField } from "formik-material-ui";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper/Paper";
import {
  TriggeringTextField,
  onNameChange,
} from "../components/triggering-text-field.component";

//** PUBLIC */

export const adminOptionsPromise = (name) => {
  const api = new Api();
  return api
    .get("/admins", { name, admin_group_ids: [4, 5], active: true })
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const countriesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/countries")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const type_searchesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/type_searches")
    .then((res) => res.data)
    .then(optionsToSelect);
};

export const sourcesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/sources")
    .then((res) => res.data)
    .then(optionsToSelect);
};

//PARENTESCO
export const relatednessOptionsPromise = async () => {
  const api = new Api();
  const res = await api.get("/relatedness");
  const options = res.data;
  return optionsToSelect(options);
};

/*CONCELHOS*/
export const countiesOptionsPromise = () => {
  const api = new Api();
  return api
    .get("/counties")
    .then((res) => res.data)
    .then(optionsToSelect);
};

/*FREGUESIAS*/
export const parishesOptionsPromise = (county) => {
  const api = new Api();
  return () =>
    api
      .get("/parishes", { county }, true)
      .then((res) => res.data)
      .then(optionsToSelect);
};

export const shouldUpdateSelect = (prevProps, props) => {
  const updatedDependentValue =
    prevProps.formik.values[prevProps.dependsOn] !==
    props.formik.values[prevProps.dependsOn];
  const updatedValue = prevProps.value !== props.value;
  return updatedValue || updatedDependentValue;
};

//** PRIVATE */

const validationSchema = object().shape({
  elderly_name: string().required("Obrigatório"),
  admin_id: string().required("Obrigatório"),
  country_id: string().required("Obrigatório"),
  source_id: string().required("Obrigatório"),
  type_search_id: string().required("Obrigatório"),
  closest_county: string().required("Obrigatório"),
  closest_parish: string().required("Obrigatório"),
});

const optionsToSelect = (options) => {
  return options.map((option) => ({ value: option.id, label: option.name }));
};

const handleSubmitting = (fn) => async (values, actions) => {
  await registChanges(values);
  fn(values)
    .then(() => actions.setSubmitting(false))
    .catch(() => actions.setSubmitting(false));
};

export const registChanges = async (data) => {
  const api = new Api();
  try {
    const res = await api.post(`/users_requests_ref_zone`, data);
    console.log(res);
  } catch (err) {
    console.log(err);
  }
};

export const RequestDetailsForm = ({
  onSubmit,
  elderly_name,
  admin_id,
  social_worker_id,
  relatedness,
  subject,
  message,
  request_type,
  is_urgent,
  request_period_id,
  country_id,
  source_id,
  type_search_id,
  closest_county,
  closest_parish,
  getForm,
  userRequestStats,
  date_of_birth,
  retirement_pension,
}) => (
  <>
    <Formik
      ref={(node) => getForm && getForm(node)}
      initialValues={{
        user_request_id: window.location.href.substring(
          window.location.href.lastIndexOf("/") + 1
        ),
        is_urgent,
        elderly_name,
        admin_id: admin_id || "",
        social_worker_id: social_worker_id || "",
        relatedness: relatedness || "",
        message: message,
        subject,
        request_period_id,
        country_id: country_id || "",
        source_id: source_id || 1,
        type_search_id: type_search_id || "",
        search_all_counties: "",
        closest_county: closest_county || "",
        closest_parish: closest_parish || "",
        request_type: request_type || "Exclusivo",
        date_of_birth: date_of_birth || "",
        retirement_pension: retirement_pension || "",
      }}
      onSubmit={handleSubmitting(onSubmit)}
      //onSubmit={(values) => {console.log(values)}}
      validationSchema={validationSchema}
      validateOnChange={true}
      validateOnBlur={false}
      render={({
        values,
        errors,
        status,
        touched,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        setFieldValue,
        setFieldTouched,
      }) => {
        return (
          <Grid item md={12}>
            <Form onSubmit={handleSubmit}>
              <Grid container>
                <Grid item md={4} className="new-card-inner">
                  <Field
                    name="admin_id"
                    label="Consultor"
                    search
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    value={"" + values.admin_id}
                    optionsFetcher={adminOptionsPromise}
                    component={MaterialSelectFormik}
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner">
                  <MaterialSelectFormik
                    name="country_id"
                    label="Pais de origem"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    value={values.country_id}
                    optionsFetcher={countriesOptionsPromise}
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner">
                  <Field
                    name="elderly_name"
                    label="Nome do Idoso"
                    variant="outlined"
                    autocomplete="off"
                    type="text"
                    component={TriggeringTextField}
                    onChange={(e) => onNameChange(e, setFieldValue, values)}
                    fullWidth
                  />
                </Grid>

                <Grid item md={4} className="new-card-inner">
                  <br />
                  <MaterialSelectFormik
                    name="source_id"
                    label="Origem"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    value={values.source_id}
                    optionsFetcher={sourcesOptionsPromise}
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner">
                  <br />
                  <MaterialSelectFormik
                    name="type_search_id"
                    label="Tipo de Pesquisa"
                    onChange={setFieldValue}
                    onBlur={setFieldTouched}
                    value={values.type_search_id}
                    optionsFetcher={type_searchesOptionsPromise}
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner mt-4">
                  <Field
                    name="relatedness"
                    value={values.relatedness}
                    label="Parentesco"
                    optionsFetcher={relatednessOptionsPromise}
                    onChange={setFieldValue}
                    component={MaterialSelectFormik}
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner mt-2">
                  <Field
                    name="date_of_birth"
                    label="Data de nascimento do idoso"
                    type="date"
                    variant="outlined"
                    margin="normal"
                    component={TextField}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    required
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner mt-2">
                  <Field
                    name="retirement_pension"
                    label="Reforma do Idoso (em €)"
                    type="number"
                    variant="outlined"
                    margin="normal"
                    component={TextField}
                    onChange={setFieldValue}
                    value={"" + values.retirement_pension}
                    fullWidth
                  />
                </Grid>
                <Grid item md={4} className="new-card-inner">
                  <br />
                  <div
                    className="mb-1"
                    onClick={() => {
                      values.closest_parish = "";
                    }}
                  >
                    <FastField
                      name="closest_county"
                      placeholder="search_county"
                      label="Concelho"
                      onChange={setFieldValue}
                      value={values.closest_county}
                      limit={20}
                      minLength={3}
                      optionsFetcher={countiesOptionsPromise}
                      component={MaterialSelectFormik}
                      required
                    />
                  </div>
                  {values.closest_county && (
                    <FastField
                      name="closest_parish"
                      placeholder="search_parishes"
                      label="Freguesia *"
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      value={values.closest_parish}
                      limit={20}
                      minLength={3}
                      optionsFetcher={parishesOptionsPromise(
                        values.closest_county
                      )}
                      dependsOn="closest_county"
                      shouldUpdate={shouldUpdateSelect}
                      component={MaterialSelectFormik}
                      margin="none"
                      required
                    />
                  )}
                </Grid>

                <Grid
                  item
                  md={12}
                  className="new-card-inner"
                  style={{ marginTop: "20px" }}
                >
                  <Field
                    name="subject"
                    label="Assunto"
                    variant="outlined"
                    margin="normal"
                    type="text"
                    component={TextField}
                    multiline
                    fullWidth
                  />
                  <Paper className="paper-notes">
                    Será preenchido automaticamente em pedidos encaminhados
                    quando for guardado o nome do idoso.
                  </Paper>
                </Grid>
                <Grid item md={12} className="new-card-inner">
                  <Field
                    name="message"
                    label="Mensagem (origem site)"
                    variant="outlined"
                    margin="normal"
                    type="text"
                    component={TextField}
                    multiline
                    fullWidth
                    rows="10"
                    disabled
                    InputProps={{ style: { fontSize: 16, color: "#696969" } }}
                  />
                </Grid>
              </Grid>
            </Form>
          </Grid>
        );
      }}
    />
  </>
);
